import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> & {
    items?: { label: string; value: string; id: string }[];
  }
>(({ className, items, ...props }, ref) => (
  <RadioGroupPrimitive.Root className={cn("flex flex-col gap-2", className)} {...props} ref={ref}>
    {items?.map(item => (
      <label
        key={item.id}
        htmlFor={item.id}
        className="flex cursor-pointer items-center space-x-2 rounded p-1 hover:bg-accent/50"
      >
        <RadioGroupPrimitive.Item
          id={item.id}
          value={item.value}
          className={cn(
            "h-4 w-4 rounded-full border border-primary text-primary focus:outline-none disabled:opacity-50",
          )}
        >
          <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
            <Circle className="h-2 w-2 fill-current" />
          </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
        <span className="cursor-pointer text-sm">{item.label}</span>
      </label>
    ))}
  </RadioGroupPrimitive.Root>
));
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    className={cn(
      "h-4 w-4 rounded-full border border-primary text-primary focus:outline-none disabled:opacity-50",
      className,
    )}
    {...props}
  >
    <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
      <Circle className="h-2 w-2 fill-current" />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
));
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
